const useStyles = (theme) => ({
  dialogPaper: {
    width: "700px",
    height: "600px",
    maxWidth: "none",
    maxHeight: "none",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
  },
  dialogContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialogContent: {
    pt: "12px !important",
    pb: "12px !important",
    px: 3,
    flex: 1,
    overflowY: "auto",
  },
  dialogTitle: {
    px: 3,
    pt: 2.5,
    pb: 0,
  },
  dialogActions: {
    px: 3,
    pb: 2.5,
    pt: 2,
    gap: 1,
  },
  textfield: {
    maxWidth: "100%",
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      boxShadow: "none",
      "&:hover": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
      },
    },
  },
  virtualizedOption: {
    padding: "0 8px 0 0",
    height: "100%",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  optionLabel: {
    fontSize: "0.85rem",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  sectionNumber: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: "0.75rem",
    fontWeight: 700,
    flexShrink: 0,
  },
});

export default useStyles;
